import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SelectButtonQuizType2 from '../../components/SelectButtonQuizType2.jsx';
import SelectPictureQuizType from '../../components/SelectPictureQuizType.jsx';
import './SelectPage2.scss';

const quizData2 = [
	{
		no: 1,
		type: 1,
		title: '놀이기구 타며 손들고 인사하는 판다는 누구일까요?',
		picture: '/assets/2-1.webp',
		button1: '루이바오',
		button2: '후이바오',
		answer: '1',
		explanation:
			'[1탄 참고] 귀사이 정수리 넓이나, 콧잔등 가마, 썬글라스를 보면 알아 볼 수 있어요!\n이 사진에서 루이와 후이를 구분하는 방법은 콧잔등을 확인해야 해요! 루이의 콧잔등은 가마가 2개이고, 후이의 콧잔등 가마는 1개에요!',
	},
	{
		no: 2,
		type: 1,
		title: '엄마와 나란히 누워있는 바오들 중 후이를 찾아주세요.',
		picture: '/assets/2-2.webp',
		button1: '왼쪽',
		button2: '오른쪽',
		answer: '2',
		explanation:
			'[1탄 참고] 이 사진에서 루이와 후이를 구분하는 방법은 등의 볼레로와 몸매에요. 루이에 비해 후이는 몸매가 둔둔하고 통통한 것을 볼 수 있어요~',
	},
	{
		no: 3,
		type: 1,
		title: '앞서서 나무를 오르는 판다는 누구일까요?',
		picture: '/assets/2-3.gif',
		button1: '루이바오',
		button2: '후이바오',
		answer: '2',
		explanation:
			'[1탄 참고] 테스트 1탄을 보고 오셨다면 맞출 수 있는 문제~!! 움직이는 영상 속의 루이바오와 후이바오를 관찰해보세요~!',
	},
	{
		no: 4,
		type: 1,
		title: '나무에서 떨어진 바오들, 어느쪽이 루이일까요?',
		picture: '/assets/2-4.webp',
		button1: '왼쪽',
		button2: '오른쪽',
		answer: '2',
		explanation:
			'[1탄 참고] 어부바 나무에서 떨어지는 우당탕 바오자매들~ 바오들의 생김새를 관찰하면 알아맞출 수 있어요! 오른쪽 아이가 루이입니다.',
	},
	{
		no: 5,
		type: 1,
		title: '비누방울 불고 있는 판다는 누구일까요?',
		picture: '/assets/2-5.webp',
		button1: '루이바오',
		button2: '후이바오',
		answer: '2',
		explanation:
			'[1탄 참고] 짱구 옆태를 똑 닮은 그 판다! 여유롭게 비누방울을 불고 있네요 ㅋㅋ',
	},
	{
		no: 6,
		type: 1,
		title: '나무에 올라가서 휴식을 취하는 판다는 누구일까요?',
		picture: '/assets/2-6.webp',
		button1: '루이바오',
		button2: '후이바오',
		answer: '2',
		explanation:
			'루이바오와 후이바오는 꼬리 모양으로 비교할 수 있어요. 루이바오는 조금 털이 듬성한 편이고 후이바오는 꼬리가 짧고 털이 풍성한 편이에요.',
	},
	{
		no: 7,
		type: 1,
		title: '사육사 앞에 서있는 판다는 누구일까요?',
		picture: '/assets/2-7.gif',
		button1: '루이바오',
		button2: '후이바오',
		answer: '1',
		explanation:
			'[1탄 참고] 야생의 맹수미를 뽐내는 이 판다는 생김새로 알아볼 수 있죠? 이 배틀의 승자는 누구일까요? ㅋㅋ',
	},
	{
		no: 8,
		type: 1,
		title: '뱃살스키를 타는 이 판다는 누구일까요?',
		picture: '/assets/2-8.gif',
		button1: '루이바오',
		button2: '후이바오',
		answer: '2',
		explanation:
			'잘 웃는 루이바오는 햇살이, 뱃살이 통통한 후이바오는 뱃살이라는 별명이 있어요~ 이 영상은 [어와둥둥] 유튜브에 나온 후이바오가 뱃살로 스키를 타는 재미있는 장면이에요.',
	},
	{
		no: 9,
		type: 1,
		title: '야무지게 문열고 들어가는 이 판다는 누구일까요?',
		picture: '/assets/2-9.gif',
		button1: '루이바오',
		button2: '후이바오',
		answer: '1',
		explanation:
			'[1탄 참고] 똑똑해서 문까지 열어버리는 이 판다는 생김새를 보고 알아맞혀 보세요~!',
	},
	{
		no: 10,
		type: 1,
		title: '이 발바닥은 누구의 것일까요?',
		picture: '/assets/2-10.webp',
		button1: '루이바오',
		button2: '후이바오',
		answer: '2',
		explanation:
			'루이바오와 후이바오 영상을 꾸준히 열심히 본 임오, 삼툔들이 알 수 있는 발바닥이에요~ 후이바오 어릴 적에, 송바오가 후이바오 발바닥을 보며 영상 속에서 소원(?)을 빌었는데, 후이바오가 커서 그 소원을 실제로 이뤄주어 효녀 판다라는 말을 듣고 있죠 :)',
	},
];

const SelectPage2 = () => {
	const [currentQuizNo, setCurrentQuizNo] = useState(1);
	const [score, setScore] = useState(0);
	const currentQuiz = quizData2.find(quiz => quiz.no === currentQuizNo);
	const navigate = useNavigate();

	// useEffect(() => {
	// 	document.body.style.overflow = 'hidden';

	// 	return () => {
	// 		document.body.style.overflow = 'auto';
	// 	};
	// }, []);

	// 초기 이미지 미리 로드
	useEffect(() => {
		if (quizData2.length > 0) {
			const firstImg = new Image();
			firstImg.src = quizData2[0].picture;
		}
	}, []);

	useEffect(() => {
		const nextQuiz = quizData2.find(quiz => quiz.no === currentQuizNo + 1);
		if (nextQuiz && nextQuiz.picture) {
			const img = new Image();
			img.src = nextQuiz.picture;
		}
	}, [currentQuizNo]);

	const handleAnswer = selectedAnswer => {
		if (selectedAnswer.toString() === currentQuiz.answer) {
			setScore(prevScore => {
				const updatedScore = prevScore + 1;
				processNextStep();
				return updatedScore;
			});
		} else {
			processNextStep();
		}
	};

	useEffect(() => {
		if (currentQuizNo > quizData2.length) {
			navigate('/loading2', { state: { score } });
			window.scrollTo(0, 0);
		}
	}, [currentQuizNo, score, navigate]);
	window.scrollTo(0, 0);

	const processNextStep = () => {
		setCurrentQuizNo(prev => prev + 1);
	};

	return (
		<div className="quiz-container2">
			<div className="quiz-head">
				<div className="quiz-head-info">
					<div className="quiz-head-info-num">
						<span className="quiz-head-info-num-text">
							Q. {currentQuiz?.no}
						</span>
					</div>
					<div className="quiz-head-info-indicator">
						<span className="quiz-head-info-indicator-text">
							{currentQuizNo} / {quizData2.length}
						</span>
					</div>
				</div>
				<div className="quiz-head-title">
					<p className="quiz-head-title-text">{currentQuiz?.title}</p>
				</div>
			</div>
			<div className="quiz-body">
				{currentQuiz?.type === 1 ? (
					<SelectButtonQuizType2
						picture={currentQuiz?.picture}
						button1={currentQuiz?.button1}
						button2={currentQuiz?.button2}
						onAnswer={handleAnswer}
					/>
				) : (
					<SelectPictureQuizType
						picture1={currentQuiz?.picture1}
						picture2={currentQuiz?.picture2}
						onAnswer={handleAnswer}
					/>
				)}
			</div>
		</div>
	);
};

export default SelectPage2;
